module.exports = __webpack_public_path__ + "img/ci.e138db19.svg";